
import {
    Form,
    FormField,
    FormSection,
    FormType,
    InputType,
    FilteredValue,
    DropdownFilterContext,
    ReactiveComputedFieldContext,
    ReactiveFieldLogicContext,
    ReactiveFormChangedField,
    ReactiveFormValue,
} from '@fitogest/reactive-form-builder/interfaces';
import { CamposListsDefinition } from './list-variables';
import { CamposEnvironmentDefinition } from '../environment-variables';
import { VisitasVariedadMesModel } from 'src/app/models/visitas_variedad_mes/visitas_variedad_mes.model';
import { ParcelasModel } from 'src/app/models/form-common/parcelas.model';
import { FincasModel } from 'src/app/models/form-common/fincas.module';

export class CamposFormDefinition {    
  public formType!: FormType;

  public env: CamposEnvironmentDefinition = new CamposEnvironmentDefinition();

  public lists: CamposListsDefinition = new CamposListsDefinition();

  public model: ReactiveFormValue<ParcelasModel> = {} as ReactiveFormValue<ParcelasModel>;

  public tag: ReactiveFormChangedField<ParcelasModel> = '';
    
  public formFieldsSection!: FormSection<object>;

  public formFieldsTitular!: FormSection<object>;

  public formFieldsResponsable!: FormSection<object>;
    
  public formFields!: Form<ParcelasModel>;

  public formFieldsCultivos!: Form<VisitasVariedadMesModel>;

  public fieldNames: FormField<any>[] = [];

  public fieldLabels: string[] = [];

  public openDialog = false;

  public mapaAbierto = false;
      
  public origin = 'parcelas-form';
      
  public finca = 'finca';
      
  public localidad = 'localidad';
      
  public cultivo = 'cultivo';
      
  public variedad = 'variedad';
      
  public parcelaNombre = 'nombre Campo';
      
  public mapaOpened = false;

  constructor(
    type: FormType, 
    _model: Record<string,string>,
    table: (string[] | string[][])[] | null
  ) {
    this.formType = +type;
    
    this.formFields = {
      name: 'campos',
      header: 'Datos del Campo',
      type: this.formType,
      sections: this.getFormSections(),
      table: { title: '', showIndex: false, data: table?.[0], style: table?.[1]},
      uploadButton: {
        isEnabled: false,
        label: ''
      },
      signed: false
    };

    this.formFieldsCultivos = {
      name: 'visitas_variedad_mes',
      header: '',
      type: FormType.CREATION,
      sections: this.getFormSectionsCultivos(),
      table: { title: '', showIndex: false, data: table?.[0], style: table?.[1]},
      uploadButton: {
        isEnabled: false,
        label: ''
      },
      signed: false
    };
  }



  public getFormFieldsDatosParcela(): FormField<any>[] {
    const formFieldsDatosParcela: FormField<any>[] = [
        {
            name: 'nombre',
            vinculatedFields: undefined,
            label: 'Nombre',
            input: {type: InputType.TEXT, isEditable: true},
            width: 3,
            conditions: {
                isRememberedOnDuplicate: true,
                isRequired: true,
                isRetained: false,
                hasUndoEnabled: false,
                isVisible: true,
            },
            order: 1
        },
        {
            name: 'superficie_sigpac',
            vinculatedFields: undefined,
            label: 'Sup.\xa0Sigpac\xa0' + this.env.uds_medida,
            input: {type: InputType.TEXT, isEditable: true},
            width: 3,
            conditions: {
                isRememberedOnDuplicate: true,
                isRequired: true,
                isRetained: false,
                hasUndoEnabled: false,
                isVisible: true,
            },
            order: 2
        },
        {
            name: 'superficie_cultivada',
            vinculatedFields: undefined,
            label: 'Sup. Cultivada\xa0' + this.env.uds_medida,
            input: {type: InputType.TEXT, isEditable: true},
            width: 3,
            conditions: {
                isRememberedOnDuplicate: true,
                isRequired: true,
                isRetained: false,
                hasUndoEnabled: false,
                isVisible: true,
            },
            order: 3
        },
        {
            name: this.formType < 3 ? 'id_cultivo' : 'cultivo',
            vinculatedFields: undefined,
            label: 'Cultivo',
            input: {
                type: InputType.DROPDOWN_SEARCH, 
                isEditable: true,
                data: this.lists.cultivos,
                dropdownConfiguration: {
                    valuePrimaryKey: 'id',
                }
            },
            width: 3,
            conditions: {
                isRememberedOnDuplicate: true,
                isRequired: true,
                isRetained: false,
                hasUndoEnabled: false,
                isVisible: true,
            },
            buttons: [
                {
                    class: 'btn btn-success border rounded-circle shadow-sm p-0 d-flex align-items-center justify-content-center',
                    style: `
                        width: 26px;
                        height: 26px;
                        margin-left: 6px;
                        font-size: .95rem;
                        transform: translateY(-0.5rem);
                    `,
                    icon: 'fa fa-plus',
                    label: '',
                    tooltip: 'Añadir nuevo valor',
                    tooltipPosition: 'top',
                    function: () => this.openDialog = true
                }
            ],
            order: 4
        },
        {
            name: this.formType < 3 ? 'id_variedad' : 'variedad',
            vinculatedFields: undefined,
            label: 'Variedad',
            input: {
                type: InputType.DROPDOWN,
                isEditable: true,
                data: this.lists.variedades,
                dropdownConfiguration: {
                    valuePrimaryKey: 'id',
                    filter: (
                        it: FilteredValue<VisitasVariedadMesModel>,
                        context?: DropdownFilterContext<VisitasVariedadMesModel>,
                    ) => it.value?.cultivo === this.resolveSelectedCultivo(context)?.cultivo,
                }
            },
            width: 3,
            conditions: {
                isRememberedOnDuplicate: true,
                isRequired: true,
                isRetained: false,
                hasUndoEnabled: false,
                isVisible: true,
            },
            order: 5
        },
        {
            name: 'marco',
            vinculatedFields: undefined,
            label: 'Marco\xa0(ancho\xa0x\xa0largo)',
            input: {
                type: InputType.TWO_FIELDS_CONCAT, 
                isEditable: true,
                twoFieldsConcatConfiguration: {
                    subField1: 'marco_ancho',
                    separator: 'x',
                    subField2: 'marco_largo',
                }
            },
            width: 3,
            conditions: {
                isRememberedOnDuplicate: true,
                isRequired: true,
                isRetained: false,
                hasUndoEnabled: false,
                isVisible: true,
            },
            order: 6
        },
        {
            name: 'anyo_plantacion',
            vinculatedFields: undefined,
            label: 'Año\xa0de\xa0plantación',
            input: {type: InputType.TEXT, isEditable: true},
            width: 3,
            conditions: {
                isRememberedOnDuplicate: true,
                isRequired: false,
                isRetained: false,
                hasUndoEnabled: false,
                isVisible: true,
            },
            order: 7
        },
        {
            name: 'plantas',
            vinculatedFields: undefined,
            label: 'Nº\xa0Árboles/Plantas',
            input: {type: InputType.TEXT, isEditable: true},
            width: 3,
            conditions: {
                isRememberedOnDuplicate: true,
                isRequired: false,
                isRetained: false,
                hasUndoEnabled: false,
                isVisible: true,
            },
            order: 8
        },
        {
            name: 'patron', 
            vinculatedFields: undefined,
            label: this.model.cultivo === 'VIÑA' ? 'Portainjertos' : 'Patrón',
            input: {
                type: InputType.DROPDOWN_SEARCH, 
                isEditable: true,
                data: this.lists.patron,
                dropdownConfiguration: {
                    swap: (it: FormField<object>, context?: ReactiveFieldLogicContext<object>) => {
                        const cultivo = this.resolveSelectedCultivo(context)?.cultivo ?? this.model.cultivo ?? '';
                        const isVineyard = cultivo.toUpperCase() === 'VIÑA';

                        if (isVineyard) {
                            it.label = 'Portainjertos';
                        } else if (this.env.appName === 'momparler') {
                            it.label = 'Formato';
                        } else {
                            it.label = 'Patrón';
                        }

                        it.input.data = this.getPatron(cultivo);
                    },
                }
            },
            updateValue: (it: FormField<object>) => {
                if (this.model.cultivo === 'VIÑA') {
                    it.label = 'Portainjertos';
                } else {
                    it.label = 'Patrón';
                }
            },
            width: 3,
            conditions: {
                isRememberedOnDuplicate: true,
                isRequired: false,
                isRetained: false,
                hasUndoEnabled: false,
                isVisible: true,
            },
            order: 9
        }
    ];

    this.fieldNames = this.fieldNames.concat(formFieldsDatosParcela.filter((it) => it.conditions.isVisible));
    this.fieldLabels = this.fieldLabels.concat(formFieldsDatosParcela.filter((it) => it.conditions.isVisible).map(it => it.label));
    return formFieldsDatosParcela.sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
  }

  public getFormFieldsDatosSigpac(): FormField<any>[] {
    const formFieldsDatosSigpac: FormField<any>[] = [
        {
            name: 'cod_provincia', 
            vinculatedFields: undefined,
            label: 'Cod. Provincia', 
            input: {type: InputType.TEXT, isEditable: true},
            width: 3,
            conditions: {
                isRememberedOnDuplicate: true,
                isRequired: false,
                isRetained: false,
                hasUndoEnabled: false,
                isVisible: true,
            },
            order: 1
        },
        {
            name: 'municipio', 
            vinculatedFields: undefined,
            label: 'Municipio', 
            input: {type: InputType.TEXT, isEditable: true},
            width: 3,
            conditions: {
                isRememberedOnDuplicate: true,
                isRequired: false,
                isRetained: false,
                hasUndoEnabled: false,
                isVisible: true,
            },
            order: 2
        },
        {
            name: 'poligono', 
            vinculatedFields: undefined,
            label: 'Polígono', 
            input: {type: InputType.TEXT, isEditable: true},
            width: 3,
            conditions: {
                isRememberedOnDuplicate: true,
                isRequired: false,
                isRetained: false,
                hasUndoEnabled: false,
                isVisible: true,
            },
            order: 3
        },
        {
            name: 'numero', 
            vinculatedFields: undefined,
            label: 'Nº Parcela', 
            input: {type: InputType.TEXT, isEditable: true},
            width: 3,
            conditions: {
                isRememberedOnDuplicate: true,
                isRequired: false,
                isRetained: false,
                hasUndoEnabled: false,
                isVisible: true,
            },
            order: 4
        },
        {
            name: 'recinto', 
            vinculatedFields: undefined,
            label: 'Recinto', 
            input: {type: InputType.TEXT, isEditable: true},
            width: 3,
            conditions: {
                isRememberedOnDuplicate: true,
                isRequired: false,
                isRetained: false,
                hasUndoEnabled: false,
                isVisible: true,
            },
            order: 5
        }
    ];

    this.fieldNames = this.fieldNames.concat(formFieldsDatosSigpac.filter((it) => it.conditions.isVisible));
    this.fieldLabels = this.fieldLabels.concat(formFieldsDatosSigpac.filter((it) => it.conditions.isVisible).map(it => it.label));
    return formFieldsDatosSigpac.sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
  }

  public getFormFieldsCultivos(): FormField<any>[] {
    const formFieldsCultivos: FormField<any>[] = [
        {
            name: 'cultivo',
            vinculatedFields: undefined,
            label: 'Cultivo',
            input: {type: InputType.TEXT, isEditable: true},
            width: 6,
            conditions: {
                isRememberedOnDuplicate: true,
                isRequired: true,
                isRetained: false,
                hasUndoEnabled: false,
                isVisible: true,
            },
            order: 1
        },
        {
            name: 'variedad',
            vinculatedFields: undefined,
            label: 'Variedad',
            input: {type: InputType.TEXT, isEditable: true},
            required: true,
            width: 6,
            conditions: {
                isRememberedOnDuplicate: true,
                isRequired: true,
                isRetained: false,
                hasUndoEnabled: false,
                isVisible: true,
            },
            order: 2
        },
    ];

    this.fieldNames = this.fieldNames.concat(formFieldsCultivos.filter((it) => it.conditions.isVisible));
    this.fieldLabels = this.fieldLabels.concat(formFieldsCultivos.filter((it) => it.conditions.isVisible).map(it => it.label));
    return formFieldsCultivos.sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
  }
  

    public getHiddenFields(): FormField<any>[] {
      const hiddenFields: FormField<any>[] = [
        {
          name: 'id',
          vinculatedFields: undefined,
          label: '',
          input: {
            type: InputType.HIDDEN,
            defaultValue: this.model.id,
            isEditable: false
          },
          width: 2,
          conditions: {
            isRememberedOnDuplicate: true,
            isRequired: false,
            isRetained: false,
            hasUndoEnabled: false,
            isVisible: true,
          },
          order: 1
        },
            {
                name: 'id_cliente',
                vinculatedFields: undefined,
                label: '',
                input: {
                    type: InputType.HIDDEN,
                    defaultValue: this.resolveClientId(),
                    isEditable: false
                },
                computed: {
                    dependsOn: ['id_finca', 'finca'],
                    resolve: (context: ReactiveComputedFieldContext<ParcelasModel>) => this.resolveClientId(context),
                },
                width: 2,
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: false,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: this.env.hasClients
                },
                order: 2
            },
            {
                name: 'id_usuario',
                vinculatedFields: undefined,
                label: '',
                input: {
                    type: InputType.HIDDEN,
                    defaultValue: this.resolveUserId(),
                    isEditable: false
                },
                computed: {
                    dependsOn: ['id_finca', 'finca'],
                    resolve: (context: ReactiveComputedFieldContext<ParcelasModel>) => this.resolveUserId(context),
                },
                width: 2,
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: false,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: true
                },
                order: 3
            },
            {
                name: 'cultivo',
                vinculatedFields: ['id_cultivo'],
                label: '',
                input: { type: InputType.HIDDEN, isEditable: false },
                width: 2,
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: false,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: true
                },
                computed: {
                    dependsOn: ['id_cultivo', 'cultivo'],
                    resolve: (context: ReactiveComputedFieldContext<ParcelasModel>) => {
                        return this.resolveSelectedCultivo(context)?.cultivo ?? this.model.cultivo ?? '';
                    },
                },
                order: 4
            },
            {
                name: 'variedad',
                vinculatedFields: ['id_variedad'],
                label: '',
                input: { type: InputType.HIDDEN, isEditable: false },
                width: 2,
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: false,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: true
                },
                computed: {
                    dependsOn: ['id_variedad', 'variedad'],
                    resolve: (context: ReactiveComputedFieldContext<ParcelasModel>) => {
                        return this.resolveSelectedVariedad(context)?.variedad ?? this.model.variedad ?? '';
                    },
                },
                order: 5
            },
      ];
  
      this.fieldNames = this.fieldNames.concat(hiddenFields.filter((it) => it.conditions.isVisible));
      this.fieldLabels = this.fieldLabels.concat(hiddenFields.filter((it) => it.conditions.isVisible).map(it => it.label));
      return hiddenFields.sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
    }

    private resolveClientId(context?: ReactiveComputedFieldContext<ParcelasModel>): unknown {
        if (this.env.cliente?.id) {
            return this.env.cliente.id;
        }

        return this.resolveSelectedFinca(context)?.id_cliente ?? this.model.id_cliente ?? '';
    }

    private resolveUserId(context?: ReactiveComputedFieldContext<ParcelasModel>): unknown {
        if (!this.env.showTareasMto) {
            return this.env.usuario?.id ?? this.resolveSelectedFinca(context)?.id_usuario ?? '';
        }

        return !FormType.EDITION ? this.env.usuario.id : '';
    }

    private resolveSelectedFinca(context?: ReactiveComputedFieldContext<ParcelasModel>): FincasModel | null {
        const selectedValue = this.getContextValue(context, 'id_finca') ?? this.getContextValue(context, 'finca')
            ?? this.model.id_finca ?? this.model.finca;

        if (this.isRecord(selectedValue)) {
            return selectedValue as unknown as FincasModel;
        }

        return this.lists.fincas.values
            .map(option => option.value)
            .find((finca): finca is FincasModel => finca !== null && (
                this.sameValue(finca.id, selectedValue)
                || this.sameValue(finca.id_finca, selectedValue)
                || this.sameValue(finca.nombre, selectedValue)
            )) ?? null;
    }

    private resolveSelectedCultivo(context?: unknown): VisitasVariedadMesModel | null {
        const selectedValue = this.getContextValue(context, 'id_cultivo') ?? this.getContextValue(context, 'cultivo')
            ?? this.model.id_cultivo ?? this.model.cultivo;

        return this.resolveVariedadMesEntity(this.lists.cultivos.values.map(option => option.value), selectedValue, 'cultivo');
    }

    private resolveSelectedVariedad(context?: unknown): VisitasVariedadMesModel | null {
        const selectedValue = this.getContextValue(context, 'id_variedad') ?? this.getContextValue(context, 'variedad')
            ?? this.model.id_variedad ?? this.model.variedad;

        return this.resolveVariedadMesEntity(this.lists.variedades.values.map(option => option.value), selectedValue, 'variedad');
    }

    private resolveVariedadMesEntity(
        values: Array<VisitasVariedadMesModel | null>,
        selectedValue: unknown,
        labelField: 'cultivo' | 'variedad',
    ): VisitasVariedadMesModel | null {
        if (this.isRecord(selectedValue)) {
            return selectedValue as unknown as VisitasVariedadMesModel;
        }

        return values.find((value): value is VisitasVariedadMesModel => value !== null && (
            this.sameValue(value.id, selectedValue)
            || this.sameValue(value.id_cultivo, selectedValue)
            || this.sameValue(value.id_variedad, selectedValue)
            || this.sameValue(value.codigo_cultivo, selectedValue)
            || this.sameValue(value.codigo_variedad, selectedValue)
            || this.sameValue(value[labelField], selectedValue)
        )) ?? null;
    }

    private getContextValue(context: unknown, fieldName: string): unknown {
        if (this.hasGetValue(context)) {
            return context.getValue(fieldName);
        }

        if (this.hasModelGetter(context)) {
            return context.model.get(fieldName)?.value;
        }

        return undefined;
    }

    private hasGetValue(context: unknown): context is { getValue: (fieldName: string) => unknown } {
        return this.isRecord(context) && typeof context['getValue'] === 'function';
    }

    private hasModelGetter(context: unknown): context is { model: { get: (fieldName: string) => { value: unknown } | null } } {
        return this.isRecord(context) && this.isRecord(context['model']) && typeof context['model']['get'] === 'function';
    }

    private sameValue(first: unknown, second: unknown): boolean {
        if (first === null || first === undefined || second === null || second === undefined) {
            return false;
        }

        return String(first) === String(second);
    }

    private isRecord(value: unknown): value is Record<string, unknown> {
        return typeof value === 'object' && value !== null;
    }

    
  private getFormSections(): FormSection<any>[] {
    const sections: FormSection<any>[] = [
      {
        name: '',
        width: 12,
        isVisible: true,
        fields: this.getFormFieldsDatosParcela(),
        order: 1
      },
      {
        name: 'Datos SigPAC',
        width: 12,
        isVisible: true,
        fields: this.getFormFieldsDatosSigpac(),
        buttons: [{
            class: 'btn btn-warning text-nowrap',
            style: 'margin-left:0px !important',
            icon: 'fa fa-search',
            label: ' Mapa',
            isVisible: this.env.appName !== 'agrogestSIEX',
            function: () => this.abreMapa()
        }],
        order: 2
      },
      {
        name: '',
        width: 12,
        isVisible: true,
        fields: this.getHiddenFields(),
        order: 3
      },
    ];

    return sections.sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
  }
  
  private getFormSectionsCultivos(): FormSection<any>[] {
    const sections: FormSection<any>[] = [
      {
        name: '',
        width: 12,
        isVisible: true,
        fields: this.getFormFieldsCultivos(),
        order: 1
      },
    ];

    return sections.sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
  }

    private getPatron(cultivo: string) {
        switch (cultivo.toLowerCase()) {
            case 'cerezo':          return this.lists.patronCerezo;
            case 'ciruelo':         return this.lists.patronCiruelo;
            case 'mandarinos':      return this.lists.patronCitricos;
            case 'naranjos':        return this.lists.patronCitricos;
            case 'lima':            return this.lists.patronCitricos;
            case 'limoneros':       return this.lists.patronCitricos;
            case 'pomelo':          return this.lists.patronCitricos;
            case 'pomelos':         return this.lists.patronCitricos;
            case 'manzano':         return this.lists.patronManzano;
            case 'pera':            return this.lists.patronPera;
            case 'peral':           return this.lists.patronPera;
            case 'viña':            return this.lists.patronVina;
            case 'almendro':        return this.lists.patronAlmendro;
            case 'melocotonero':    return this.lists.patronMelocotonero;
            default:                return this.lists.patron;
        }
    }

    private abreMapa() {
        this.mapaOpened = true;

        if (
            !this.model.nombre ||
            !this.model.id_cultivo ||
            !this.model.id_variedad
        ) {
            alert ('Debe rellenar los campos obligatorios antes de abrir el Mapa.');
            return;
        }

        this.mapaAbierto = !this.mapaAbierto;
        this.finca = this.model.nombre || '';
        this.cultivo = this.model.cultivo || '';
        this.variedad = this.model.variedad || '';
        
        this.parcelaNombre = this.model.nombre || '';
    }
}